import { render, staticRenderFns } from "./PostText.vue?vue&type=template&id=f39d4cac"
import script from "./PostText.vue?vue&type=script&lang=ts"
export * from "./PostText.vue?vue&type=script&lang=ts"
import style0 from "./PostText.vue?vue&type=style&index=0&id=f39d4cac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./PostText.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports